import List from 'src/storage/list';
import { validateObj, lang, api } from 'src/helpers';
import AlertManager from 'src/components/alert/AlertManager';
import LANG_CONST from 'src/helpers/lang/const';

class SettingGalleryModel extends List {
  id = 'SettingGalleryModel';
  listLimit = 4;
  defaultState = () => ({
    current: 'recent',
    gallery: {},
    total: 0,
    tags: [],
    pageIndex: 0
  });
  refreshOnInit = false;
  refreshOnSubscribe = true;

  sortBy = null;
  apiConfig = {
    refresh: {
      url: 'clinic/gallery/list',
      validation: {
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true
    },
    list: {
      url: 'clinic/gallery/list',
      validation: {
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true
    },
    delete: {
      url: 'clinic/gallery/delete',
      validation: {
        id: 'baseId'
      },
      cancellable: true
    }
  };

  _events = {
    profile: 'handleChangeProfileAndSwitchAccount',
    'ws:gallery': 'onGallery'
  };

  onGallery = (data) => {
    if (data.removed) {
      this.removeItem(data.id);
    } else if (data) this.updateItem(data);
  };

  listParams() {
    let req = {
      skip: this.state.pageIndex * this.listLimit,
      limit: this.listLimit,
      tags: this.state.tags || []
    };
    let query = this.listInput('search');
    if (query.length > 0) {
      req.query = query;
    }
    return req;
  }

  saveData = ({ id, title, description, media: rawMedia, tags = [], isMain = false }) => {
    let media = rawMedia.map((item) => (!item.file ? item : { originalName: item.file.name }));
    let files = rawMedia.filter((item) => !!item.file).map((item) => item.file);

    return new Promise((resolve) => {
      const req = {
        title,
        description,
        tags,
        media
      };
      if (id) req.id = id;

      let invalid = validateObj(req, {
        title: ['required', 'title'],
        description: 'description',
        media: !files?.length ? 'required' : 'array',
        tags: !tags?.length && !isMain ? 'required' : 'array'
      });

      if (req.media?.length > 12) {
        invalid.length++;
        invalid.media = lang.t(LANG_CONST.validation.media_limit, { limit: 12 });
      }

      if (invalid.length === 0) {
        api(isMain ? 'clinic/gallery/main' : 'clinic/gallery/modify', { files, ...req }, true).then(
          ({ error, data }) => {
            if (!error) {
              if (!isMain) !id ? this.refresh() : this.addItem({ id, ...data });
              else this.onHandleChangeProfile({ gallery: data });
            }
            resolve({
              ok: !error,
              data
            });
          }
        );
      } else {
        resolve({
          ok: false,
          invalid
        });
      }
    });
  };

  del = (id, isMain = false) => {
    AlertManager.popup(AlertManager.TYPES.WARN, {
      close: false,
      title: LANG_CONST.notice.delete,
      cancelButton: {
        label: LANG_CONST.buttons.no,
        action: (actions) => actions.hide()
      },
      actionButton: {
        label: LANG_CONST.buttons.yes,
        action: (actions) => {
          actions.setLoading(true);
          this.api('delete', { id: id || -1, isMain }, () => {
            id && this.removeItem(id);
            actions.hide();
            actions.setLoading(false);
          });
        }
      }
    });
  };

  onHandleChangeProfile = (data) => {
    const gallery = {
      main: data?.gallery?.main,
      tags: Object.keys(data?.gallery?.tags || {})
    };

    this.setState({ gallery });
  };
}

const model = new SettingGalleryModel();
export default model;
